import { Box, Container, Grid, Paper, Typography, SvgIcon, Link } from '@mui/material';
import type { FC } from 'react';
import { useRef, useContext } from 'react';
import type { ResultLayoutProps } from '../../types/components/ResultLayoutProps';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowSvg } from '../../lib/img/arrow.svg';
import { TransportTicketPickerStore } from '../../store/TransportTicketPickerContext';
import { gtmCtaNewSearch } from '../../lib/gtm/actions';

export const ResultLayout: FC<ResultLayoutProps> = (props: ResultLayoutProps) => {
    const { t } = useTranslation();
    const newSearchBox = useRef<HTMLDivElement>(null);
    const { state } = useContext(TransportTicketPickerStore);

    const { children } = props;



    return (
        <>
            <Container>
                <Paper elevation={3} sx={{ backgroundColor: '#FAFAFA', paddingBottom: 3 }}>
                    <Grid container>
                        <Grid item md={8} xs={4}>
                            <Box sx={{ backgroundColor: '#003C60', height: 58, borderRadius: '5px 0px 0px 0px' }} display={'flex'} alignItems={'center'} px={2}> 
                                <Typography variant="h3" component="h2" color="white" aria-hidden="true">
                                    {t('result')}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={4} xs={8} aria-hidden="true">
                            <Box
                                sx={{ height: 58, borderRadius: '0px 5px 0px 0px', backgroundColor: '#007373;', '&:focus': { filter: 'brightness(85%)' } }}
                                display={'flex'}
                                alignItems={'center'}
                                px={1}
                                ref={newSearchBox}
                            >
                                <SvgIcon sx={{ fill: 'none', transform: 'rotate(180deg)' }} component={ArrowSvg} viewBox="0 0 14 23" />
                                <Box ml={3}>
                                    <Link
                                        href={`/?language=${state.language}&transportMode=${state.transportMode}`}
                                        onClick={() => gtmCtaNewSearch(state, `/?language=${state.language}&transportMode=${state.transportMode}`)}
                                        sx={{
                                            textDecoration: 'none',
                                            fontWeight: 500,
                                            fontSize: '1.125rem',
                                            letterSpacing: '-0.06px',
                                            color: 'white',
                                        }}
                                        onFocus={() => {
                                            if (null !== newSearchBox.current) {
                                                newSearchBox.current.style.filter = 'brightness(85%)';
                                            }
                                        }}
                                        onBlur={() => {
                                            if (null !== newSearchBox.current) {
                                                newSearchBox.current.style.filter = 'brightness(100%)';
                                            }
                                        }}
                                    >
                                        {t('newSearch')}
                                    </Link>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    {children}
                </Paper>
            </Container>
        </>
    );
};
